import { AuthConfig } from 'angular-oauth2-oidc';
import { AppUrls } from '../app-urls';
import { AppConfig } from '../../appconfig';

export class AuthConfigHelper {
  constructor(private appConfig: AppConfig) {}

  authConfig(): AuthConfig {
    const cfg = new AuthConfig();

    cfg.requireHttps = !this.appConfig.disableOpenIdSSL(); 
    
    cfg.strictDiscoveryDocumentValidation = false;

    cfg.issuer = this.appConfig.identityUri();
    cfg.clientId = this.appConfig.identityClientId();
    cfg.scope = this.appConfig.identityScopes();

    // from old roesberg config
    // cfg.useSilentRefresh = true;
    // cfg.silentRefreshRedirectUri = AppUrls.baseUrlAngular + AppUrls.actionSilentRefresh;
    cfg.responseType = 'code';
    cfg.redirectUri = AppUrls.baseUrlAngular;

    // for testing purpose with silent refresh of tokens
    // cfg.silentRefreshTimeout = 5000;
    // cfg.timeoutFactor = 0.1;

    // If Angular shall handle sessions (multi system login for same user),
    // we could use this session system. But Ldw uses serverside internal
    // session management, so there is no need/sense for this
    // cfg.sessionCheckIFrameUrl = AppUrls.getAuthUrl(AppUrls.actionAuthSessionCheck);
    // cfg.sessionChecksEnabled = true;

    cfg.showDebugInformation = true; // Also requires enabling "Verbose" level in devtools
    cfg.clearHashAfterLogin = false; // https =//github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040;
    cfg.nonceStateSeparator = 'semicolon'; // Real semicolon gets mangled by IdentityServer's URI encoding

    return cfg;
  }
}
